import { Component, ElementRef, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { PageBase } from 't4core';
import { TerminationDialog } from '../../dialogs/TerminationDialog/TerminationDialog';
import { ContractDialog } from '../../dialogs/ContractDialog/ContractDialog';
import * as moment from 'moment';
import { T4DatatableWidget } from '../../../../t4common';


@Component({
    selector: 'Backoffice',
    templateUrl: './Backoffice.html',
})
export class BackofficeComponent extends PageBase implements AfterViewInit {
    @ViewChild("tblRepurchase", { static: false }) tblRepurchase: T4DatatableWidget;
    @ViewChild("tblOffRentActions", { static: false }) tblOffRentActions: T4DatatableWidget;
    @ViewChild("tblInvoice", { static: false}) tblInvoice: T4DatatableWidget;

    public showInvoiceQueue: boolean = true;
    public enableMultiSelect: boolean = false;
    public fullOrderSelection: boolean = false;
    public invoiceNowSelection: boolean = false;

    public isReadOnly: boolean = true;

    public lockSE: boolean = false;
    public lockDK: boolean = false;
    public lockNO: boolean = false;

    constructor(el: ElementRef) {
      super(el, "Order");

      this.isReadOnly = !this.Settings.isInAny(["BackOffice"]);
    }

  public ngAfterViewInit() {
        this.tblInvoice.dataUpdated.subscribe(x => this.updateSums());
        this.tblInvoice.filterChanged.subscribe(() => this.updateSums());
        this.tblInvoice.itemSelected.subscribe((item) => {
            if (this.fullOrderSelection) {
                this.tblInvoice.data.data.filter(x => x.TerminationId == item.TerminationId && x.Id != item.Id).map(x => this.tblInvoice.selectRow(x, true));
            }
            this.updateSums();
        });

        this.tblInvoice.itemDeselected.subscribe((item) => {
            if (this.fullOrderSelection) {
                this.tblInvoice.data.data.filter(x => x.TerminationId == item.TerminationId && x.Id != item.Id).map(x => this.tblInvoice.deselectRow(x, true));
            }
            this.updateSums();
        });

        this.getLockStatus();
    }

    /// Actions
    public async openContractDialog(vehicleId: string) {
      if (!vehicleId) return;


        var dlg = this.Dialog.open(ContractDialog, {
            maxHeight: "calc(100vh - 20px)",
            maxWidth: "calc(100vw - 20px)",
            width: "750px",
            data: {
                vehicleId: vehicleId
            }
        });

        await dlg.afterClosed().toPromise();


    }

    public anyChecked(): boolean {
        return this.tblRepurchase && this.tblRepurchase.data.renderedData.filter(function (n, i) {
            return n.Terminate;
        }).length > 0;
    }

    public async showTermination(tId: number) {
          const dialog = this.Dialog.open(TerminationDialog, {
            data: {
                TerminationId: tId
            }
          });

        await dialog.afterClosed().toPromise();

        return;
    }

    public async delayInvoice() {
        var rows = this.tblInvoice.selectedRows;

        if (rows.length > 0) {
            var ids = rows.map(x => x.TerminationId);
            var amount = 0;
            this.tblInvoice.data.data.filter(x => ids.findIndex(y => y == x.TerminationId) >= 0).map(x => amount += x.Price);

            var x = await this.UI.confirm("TO.BackOffice.headConfirmPostponeInvoice", "Confirm postpone", "TO.BackOffice.msgConfirmPostponeInvoice", "Do you want to postpone invoices with a total value of {0}.", null, [amount]);
            if (x) {
                await this.Api.get<boolean>("/TurboOrder/PostponeInvoice", { orderIds: ids });

                this.tblInvoice.update();
                alert("OK!");
                this.enableMultiSelect = false;
            }
        }
    }

    public async moveUpInvoice() {
        var rows = this.tblInvoice.selectedRows;

        if (rows.length > 0) {
            var ids = rows.map(x => x.TerminationId);
            var amount = 0;
            this.tblInvoice.data.data.filter(x => ids.findIndex(y => y == x.TerminationId) >= 0).map(x => amount += x.Price);

            var x = await this.UI.confirm("TO.BackOffice.headConfirmMoveUpInvoice", "Confirm move", "TO.BackOffice.msgConfirmMoveUpInvoice", "Do you want to invoice a total value of {0} one month earlier?", null, [amount]);
            if (x) {
                await this.Api.get<boolean>("/TurboOrder/MoveupInvoice", { orderIds: ids });

                this.tblInvoice.update();
                alert("OK!");
                this.enableMultiSelect = false;
            }
        }
    }

    public async markAsInvoiced() {
        var rows = this.tblInvoice.selectedRows;

        if (rows.length > 0) {
            var ids = rows.map(x => x.Id);
            var amount = 0;
            this.tblInvoice.data.data.filter(x => ids.findIndex(y => y == x.Id) >= 0).map(x => amount += x.Price);

            var x = await this.UI.confirm("TO.BackOffice.headConfirmMarkAsInvoiced", "Confirm invoice", "TO.BackOffice.msgConfirmMarkAsInvoiced", "Do you want to mark {0} invoices with a total value of {1} as invoiced?", null, [ rows.length, amount]);
            if (x) {
                await this.Api.get<boolean>("/TurboOrder/MarkAsInvoiced", { rowIds: ids });
                rows.map(x => x.Processed = true);
                this.tblInvoice.update();
                alert("OK!");
                this.enableMultiSelect = false;
            }
        }
    }

    public async getLockStatus() {
        var lockSE = await this.Api.get<any>("Settings/GetSetting", { key: "TurboOrder.BackOffice.InvoiceQueue.SwedenStopped" });
        this.lockSE = lockSE.BoolValue;

        var lockNO = await this.Api.get<any>("Settings/GetSetting", { key: "TurboOrder.BackOffice.InvoiceQueue.NorwayStopped" });
        this.lockNO = lockNO.BoolValue;

        var lockDK = await this.Api.get<any>("Settings/GetSetting", { key: "TurboOrder.BackOffice.InvoiceQueue.DenmarkStopped" });
        this.lockDK = lockDK.BoolValue;
    }

    public async updateLockStatus(lock: boolean, c: string) {
        if (c == "sweden") {
            var ret = await this.Api.get<any>("Settings/SaveSetting", { key: "TurboOrder.BackOffice.InvoiceQueue.SwedenStopped", dataType: "boolean", boolValue: lock });
            if (ret) {
                var lockSE = await this.Api.get<any>("Settings/GetSetting", { key: "TurboOrder.BackOffice.InvoiceQueue.SwedenStopped" });
                this.lockSE = lockSE.BoolValue;
            }
        }

        else if (c == "norway") {
            var ret = await this.Api.get<any>("Settings/SaveSetting", { key: "TurboOrder.BackOffice.InvoiceQueue.NorwayStopped", dataType: "boolean", boolValue: lock });
            if (ret) {
                var lockNO = await this.Api.get<any>("Settings/GetSetting", { key: "TurboOrder.BackOffice.InvoiceQueue.NorwayStopped" });
                this.lockNO = lockNO.BoolValue;
            }
        }

        else if (c == "denmark") {
            var ret = await this.Api.get<any>("Settings/SaveSetting", { key: "TurboOrder.BackOffice.InvoiceQueue.DenmarkStopped", dataType: "boolean", boolValue: lock });
            if (ret) {
                var lockDK = await this.Api.get<any>("Settings/GetSetting", { key: "TurboOrder.BackOffice.InvoiceQueue.DenmarkStopped" });
                this.lockDK = lockDK.BoolValue;
            }
        }
    }

    public se1: number = 0;
    public se2: number = 0;
    public se3: number = 0;
    public dk1: number = 0;
    public dk2: number = 0;
    public dk3: number = 0;
    public no1: number = 0;
    public no2: number = 0;
    public no3: number = 0;
    public sel1: number = 0;
    public sel2: number = 0;
    public sel3: number = 0;

    public updateSums() {
        this.se1 = this.sum(this.today.clone(), "Sweden");
        this.se2 = this.sum(this.today.clone().add(1, 'month'), "Sweden");
        this.se3 = this.sum(this.today.clone().add(2, 'month'), "Sweden");

        this.dk1 = this.sum(this.today.clone(), "Denmark");
        this.dk2 = this.sum(this.today.clone().add(1, 'month'), "Denmark");
        this.dk3 = this.sum(this.today.clone().add(2, 'month'), "Denmark");

        this.no1 = this.sum(this.today.clone(), "Norway");
        this.no2 = this.sum(this.today.clone().add(1, 'month'), "Norway");
        this.no3 = this.sum(this.today.clone().add(2, 'month'), "Norway");

        this.sel1 = this.sumSelected(this.today.clone());
        this.sel2 = this.sumSelected(this.today.clone().add(1, 'month'));
        this.sel3 = this.sumSelected(this.today.clone().add(2, 'month'));
    }


    public sum(month: moment.Moment, country: string): number {
        var sum = 0;

        this.tblInvoice.data.filteredData.filter(x =>
            x.InvoiceAt != null &&
            (x.InvoiceAt.isSame(month, 'month') || (month.isSame(moment(), 'month') && x.InvoiceAt < month)) &&
            x.Country == country &&
            x.Processed == false
        ).map(x => sum += x.Price);

        return sum;
    }

    public sumSelected(month: moment.Moment): number {
        var sum = 0;

        var ids = this.tblInvoice.selectedRows.map(x => x.TerminationId);
        this.tblInvoice.data.data.filter(x => ids.findIndex(y => y == x.TerminationId) >= 0 && x.InvoiceAt != null && (x.InvoiceAt.isSame(month, 'month') || (month.isSame(moment(), 'month') && x.InvoiceAt < month))).map(x => sum += x.Price);

        return sum;
    }


  public async beginComplete() {
      this.showInvoiceQueue = false;
      await new Promise<void>(resolve => setTimeout(() => resolve(), 5)).then(() => this.showInvoiceQueue = true);

      this.enableMultiSelect = true;
      this.invoiceNowSelection = false;
      this.fullOrderSelection = false;
    }

    public beginMove() {
        this.enableMultiSelect = true;
        this.invoiceNowSelection = false;
        this.fullOrderSelection = true;
    }

    public beginInvoiceNow() {
        this.enableMultiSelect = true;
        this.invoiceNowSelection = true;
        this.fullOrderSelection = true;
    }

    public async SendPurchaseOrders() {
        var result = await this.Api.get<boolean>("/TurboOrder/SendPurchaseOrders");

        if (result) {
            this.UI.alert("TO.BackOffice.headPurchaseOrdersSentAnnata", "Purchase orders sent to Annata!", "TO.BackOffice.msgPurchaseOrdersSentAnnata", "The purchase orders have been sent to Annata. (Wait time is 5 minutes)")
        }
        else {
            this.UI.alert("TO.BackOffice.headPurchaseOrdersSent", "Failed!", "TO.BackOffice.msgPurchaseOrdersSent", "The purchase orders could not be sent.")
        }
    }

    public async invoiceNow() {
        var rows = this.tblInvoice.selectedRows;

        if (rows.length > 0) {
            var ids = rows.map(x => x.TerminationId);
            var amount = 0;
            this.tblInvoice.data.data.filter(x => ids.findIndex(y => y == x.TerminationId) >= 0).map(x => amount += x.Price);

            var x = await this.UI.confirm("TO.BackOffice.headConfirmInvoiceNow", "Invoice now", "TO.BackOffice.msgConfirmInvoiceNow", "Do you want to invoice the selected orders with a total value of {0} now?", null, [amount]);
            if (x) {
                await this.Api.get<boolean>("/TurboOrder/InvoiceNow", { orderIds: ids, bypassStoppedInvoice: true });

                this.tblInvoice.update();
                alert("OK!");
                this.enableMultiSelect = false;
            }
        }
    }
}
